import pxToRem from 'assets/theme/function/px-to-rem';
import colors from 'assets/theme/base/colors';
const borders = {
    borderColor: colors.common.white,

    borderWidth: {
        0: 0,
        1: pxToRem(1),
        2: pxToRem(2),
        3: pxToRem(3),
        4: pxToRem(4),
        5: pxToRem(5),
    },

    borderRadius: {
        xs: pxToRem(3),
        sm: pxToRem(5),
        md: pxToRem(7),
        lg: pxToRem(9),
        xl: pxToRem(11),
        twoXl: pxToRem(13),
        threeXl: pxToRem(15),
        fourXl: pxToRem(21),
        fiveXl: pxToRem(25),
        round: pxToRem(100),
        section: pxToRem(160),
    },
};

export default borders;
